import { generateId, slugString } from "../strings";
import type { Nullable } from "../types";

const REPORT_NUMBER_LENGTH = 7;

export function generateReportNumber(_projectNumber: Nullable<string>) {
	const projectNumber = _projectNumber ?? generateId().slice(0, 8).toUpperCase();
	const slug = slugString(projectNumber).replace("-", "").toUpperCase();
	const id = generateId()
		.slice(-1 - REPORT_NUMBER_LENGTH, -1)
		.toUpperCase();
	return `${slug}-${id}`;
}
